class FareCalculator {
    constructor() {
        this.baseFare = 620;
        this.initialDistance = 1200; // 1.2km in meters
        this.additionalDistance = 274;
        this.additionalFare = 100;
    }

    calculateFare(distanceInMeters) {
        if (distanceInMeters <= 0) {
            return this.baseFare;
        }

        // 1.2km以下は初乗り料金のみ
        if (distanceInMeters <= this.initialDistance) {
            return this.baseFare;
        }

        // 1.2kmを超えた分について274mごとに100円追加
        const excessDistance = distanceInMeters - this.initialDistance;
        const additionalSegments = Math.floor(excessDistance / this.additionalDistance);
        const totalFare = this.baseFare + (additionalSegments * this.additionalFare);
        
        return totalFare;
    }

    getFareDetails(distanceInMeters) {
        const fare = this.calculateFare(distanceInMeters);
        
        let additionalSegments = 0;
        let additionalAmount = 0;
        
        if (distanceInMeters > this.initialDistance) {
            const excessDistance = distanceInMeters - this.initialDistance;
            additionalSegments = Math.floor(excessDistance / this.additionalDistance);
            additionalAmount = additionalSegments * this.additionalFare;
        }

        return {
            totalFare: fare,
            baseFare: this.baseFare,
            additionalAmount,
            additionalSegments,
            distanceInMeters: Math.round(distanceInMeters),
            distanceInKm: (distanceInMeters / 1000).toFixed(2)
        };
    }

    formatFare(fare) {
        return `¥${fare.toLocaleString()}`;
    }

    formatDistance(distanceInMeters) {
        if (distanceInMeters < 1000) {
            return `${Math.round(distanceInMeters)}m`;
        } else {
            return `${(distanceInMeters / 1000).toFixed(2)}km`;
        }
    }

    formatDuration(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        if (hours > 0) {
            return `${hours}時間${minutes}分${remainingSeconds}秒`;
        } else if (minutes > 0) {
            return `${minutes}分${remainingSeconds}秒`;
        } else {
            return `${remainingSeconds}秒`;
        }
    }
}

export default new FareCalculator();